import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import './polyfills';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { CookiesProvider } from 'react-cookie';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { persistor, store } from './redux/store';
import App from './App';
import { SENTRY_KEY } from './js/api/_config';

// ✅ Suppress ResizeObserver loop errors
if (typeof window !== "undefined" && window.ResizeObserver) {
  const originalError = console.error;
  console.error = (...args) => {
    if (
      args[0] &&
      typeof args[0] === "string" &&
      args[0].includes("ResizeObserver loop completed")
    ) {
      return; // ignore the warning
    }
    originalError(...args);
  };
}

// Sentry init
Sentry.init({
  dsn: SENTRY_KEY,
  release: '0.1.0',
});

ReactDOM.render(
  <Provider store={store}>
    <CookiesProvider>
      <BrowserRouter basename="/">
        <PersistGate persistor={persistor}>
          <App />
        </PersistGate>
      </BrowserRouter>
    </CookiesProvider>
  </Provider>,
  document.getElementById('root')
);
